import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './cup-results.jade'
import {Season, Match, TablePosition} from '../../models'
import query from '../../services/query'

import '@scoutgg/ftw/source/atoms/form-control/form-control'
import '@scoutgg/ftw/source/atoms/button/button'
import '../seasons'

function compareRows(a, b) {
  return (
    b.points - a.points ||
    b.diff - a.diff ||
    b.goals - a.goals
  )
}

function isDifferent(a, b) {
  return compareRows(a, b) || (a.group || '').localeCompare(b.group || '')
}

@Component('sporty')
@Template(template)
@Attribute('season', Season)
export default class CupResults extends HTMLElement {
  attached() {
    this.reload()
  }
  changeSeason({season}) {
    query({season})
  }
  seasonChange() {
    this.reload()
  }
  reload() {
    if(!this.season) return
    const params = {
      $reload: true,
      season: this.season._id,
    }
    Match.load(params).then(data => {
      this.realMatches = data.matches
      this.teams = data.teams
      this.render()
      this.buildTable(data)
    })
  }
  buildTable({matches, teams}) {
    const sport = this.season && this.season.sport
    if(!sport) return
    const groupStage = matches
      .filter(m => m.groupStage)
      .filter(m => m.teams)
      .filter(m => m.status !== 'pending')
    const existing = {}
    for(const row of (this.season.tablePositions || [])) {
      const group = row.group || ''
      const team = row.team
      const teamId = team._id || team
      const rowId = `${group}|${teamId}`
      existing[rowId] = row
    }
    const groupRanks = {}
    for(const match of groupStage) {
      const group = match.groupStage || ''
      for(let i = 0; i < match.teams.length; i++) {
        const team = match.teams[i]
        const teamId = team._id || team
        const rowId = `${group}|${teamId}`
        if(!groupRanks[rowId]) {
          groupRanks[rowId] = {
            original: existing[rowId],
            team: teamId,
            rank: 1,
            points: 0,
            goals: 0,
            against: 0,
            totalRank: 1,
            group,
          }
        }
        const row = groupRanks[rowId]
        const score = match.score || []
        const goals = score[i] || 0
        const against = score[1 - i] || 0
        row.goals += goals
        row.against += against
        row.points += goals > against
          ? 3
          : goals === against
            ? 1
            : 0
      }
    }
    const rows = Object.values(groupRanks)
    if(!rows.length) return

    const previousInGroup = {}
    var previous = rows[0]

    for(const row of rows) {
      if(compareRows(row, previous || row)) {
        row.totalRank = previous.totalRank + 1
      } else {
        row.totalRank = previous.totalRank
      }
      const inGroup = previousInGroup[row.group] || row
      if(compareRows(row, inGroup)) {
        row.rank = inGroup.rank + 1
      } else {
        row.rank = inGroup.rank
      }
      previous = row
      previousInGroup[row.group] = row
    }
    for(const row of rows) {
      if(row.original && !isDifferent(row, row.original)) {
        row.rank = row.original.rank
        row.totalRank = row.original.totalRank
      }
    }

    this.season.tablePositions = rows
  }

  diffClass(diff) {
    return diff < 0 ? 'negative' : diff ? 'positive' : 'zero'
  }

  save() {
    this.season.save({
      updatedProperties: ['tablePositions'],
    }).then(() => this.reload())
  }

  isDifferent(a, b) {
    return compareRows(a, b) || (
      a.totalRank - b.totalRank ||
      a.group.localeCompare(b.group) ||
      a.rank - b.rank ||
      a.name.localeCompare(b.name) ||
      a.against - b.against
    )
  }
}
